
import { getFormCampaign, getMeta } from "../helpers";
import { translateText, formatLocaleMessage, initializeLanguageSettings } from "../internationalization";
import { processCountryState } from "../formHelpers";
import {  hideErrors } from "../payment/paymentForm";
import { DONATION_PROGRAMS, formatMoney } from "../payment";
export class DonationForm {
    outreach;
    formCampaign;
    form;
    paymentTabSelector;
    donationTab;
    donateBtn;
    ccDonationTextEl;
    paypalDonationTextEl;
    customerTypeCheckbox;
    companyInputWrapper;
    companyInput;  
    errorBlockEl;
    errorBlockSelector;
    campaignSuccessPage;
    tryAgainRedirectTo;
    isUpgrade;
    donateReCaptcha;
    responseParams;
    donationType;
    recurringDayEl;
    dayOfMonthEl;
    title;
    totalOccurrences;
    defaultCurrency;
    translations;
    captchaWidgetId;
    defaultCountry = "US";

    //callbacks
    onFormSubmit;
    validateForm;

    constructor({ formSelector,
        paymentTabSelector,
        ccDonationTextSelector,
        paypalDonationTextSelector,
        customerTypeCheckboxId,
        companyInputWrapperId,
        companyInputId, 
        recurringDaySelectId = "Day-of-Month",
        errorBlockSelector,
        campaignSuccessPage ,
        tryAgainRedirectTo, outreach = 'FCBH', defaultCurrency = 'USD', defaultCountry = "US", captcha = true, captchaId = "donation-recaptcha", captchaWidgetId = "" }, translations = {}, isUpgrade = false  ) {
        this.outreach = outreach;
        this.defaultCurrency = defaultCurrency;
        this.defaultCountry = defaultCountry;
        this.errorBlockSelector = errorBlockSelector;
        this.form = document.querySelector(formSelector);
        this.errorBlockEl = document.querySelectorAll(errorBlockSelector)[0];
        this.isUpgrade = isUpgrade || getMeta("donationType")?.toLowerCase() === "monthly increase";
        
        this.customerTypeCheckbox = customerTypeCheckboxId? this.form.querySelector(`#${customerTypeCheckboxId}`) : undefined;
        this.companyInputWrapper = companyInputWrapperId? this.form.querySelector(`#${companyInputWrapperId}`) : undefined;
        this.dayOfMonthEl = recurringDaySelectId? this.form.querySelector(`#${recurringDaySelectId}`) : undefined;
        this.companyInput = companyInputId? this.form.querySelector(`#${companyInputId}`): undefined;
        this.campaignSuccessPage = campaignSuccessPage?? "default";
        this.tryAgainRedirectTo = tryAgainRedirectTo?? window.location.pathname;
        if (this.dayOfMonthEl) {
          this.recurringDayEl = this.dayOfMonthEl.getElementsByTagName("select")[0];
        }

        this.donationTab = paymentTabSelector? this.form.querySelector(paymentTabSelector): undefined;
        this.paymentTabSelector = paymentTabSelector;
        this.ccDonationTextEl = document.querySelectorAll(ccDonationTextSelector); 
        this.paypalDonationTextEl = paypalDonationTextSelector? document.querySelectorAll(paypalDonationTextSelector):undefined; 
        this.donateBtn = this.form.querySelectorAll("input[type='submit']")[0];
        this.donateBtn.style.display="block";

        this.formCampaign = getFormCampaign(FCBH.GIVE_FORM);
        FCBH.saveToStorage(FCBH.GIVE_FORM, this.formCampaign);
        
        this.donateReCaptcha = captcha && this.form.getElementsByClassName("g-recaptcha")? this.form.getElementsByClassName("g-recaptcha")[0]: undefined;
        if (this.donateReCaptcha) { 
          this.donateReCaptcha.id = captchaId;
        }
        this.captchaWidgetId = captchaWidgetId;

        this.donationType = this.isUpgrade? "monthly" : (getMeta("donationType")?.toLowerCase() !== "user's choice"? getMeta("donationType").toLowerCase() : undefined);
        this.translations = translations;

        this.createCallbacks();
    }
     async createCallbacks() {
      this.translations = this.translations?? await initializeLanguageSettings();
        this.addWaitMessage();
        FCBH.deleteFromStorage(this.formCampaign.localForm);
        processCountryState(this.defaultCountry);
        this.form.addEventListener("submit", (event) =>{
          console.log("donation form submitted", this.form.id);
          this.onFormSubmit(event);
        });
        this.processForm();
        this.processDefaultProgramMessage();
        this.processDefaultType();
        if ( this.companyInputWrapper) this.manageCustomerType();
        this.responseParams = this.getResponseParams();
    }
    addWaitMessage() {

        const statusLabel = document.createElement("p");
        statusLabel.name = "Give-Status";
        statusLabel.id = "Give-Status";
        statusLabel.classList.add("txt-subtitle");
        statusLabel.innerText = "Processing...";
        statusLabel.style.display = "none";
        this.ccDonationTextEl[0]?.parentElement.appendChild(statusLabel);
    }

    processForm(){
      this.donateBtn.addEventListener("click", (event) => {
        this.validateForm(event);
      });
      this.recurringDayEl?.addEventListener("change",  ({ target }) => this.saveFormInStorage("recurring_donation", target.value));
    }
    getResponseParams() {
      return {campaign: this.campaignSuccessPage, mustRedirectTo: this.tryAgainRedirectTo, isDonorUpdate: this.isUpgrade};
    }
    
    manageCustomerType() {  
      this.customerTypeCheckbox?.addEventListener('change', ({ target }) => {
        this.companyInputWrapper.style.display = target.checked ? 'block' : 'none';
        this.companyInput.value = '';
        });
    }
    updateDonationText({ currency_code, amounts, donation_message, default_donation_message, donation_text, pledge_message}) {
        if (!currency_code || !default_donation_message || !donation_message ) {
            return;
        }
        this.donationTab = this.form.querySelector(this.paymentTabSelector);
         const isRecurring = this.donationType?.toLowerCase() === 'yes' || this.donationType?.toLowerCase() === 'monthly' ;
         const isPledge = this.donationType?.toLowerCase() === 'pledge';
    
        const values = {
          currency_code: currency_code === "USD" ? "$" : `${currency_code} `,
          formatted_amount: formatMoney(String(amounts?.value).replaceAll(',', '')),
          donation_message: isPledge ? pledge_message : donation_message
        };    
        let key = !isRecurring? "campaign.single_donation_amount" : "campaign.monthly_donation_amount";
        key = this.isUpgrade? "campaign.upgrade_donation_amount" : key;
        if (isPledge) key = "campaign.pledge_donation_amount";

        const donationTexts = this.donationTab?.textContent.trim().toLowerCase() === "paypal"? this.paypalDonationTextEl : this.ccDonationTextEl;
        let message = translateText(key, this.translations);
        message = formatLocaleMessage(message, values);
        donationTexts.forEach(donationText => {
          
          let newText = message;
          if (!amounts || amounts.value <= 0) {
              newText = this.getStorage().default_donation_message;
          }
          const pledgeText = pledge_message || this.getStorage().pledge_message || '';
          donationText.textContent = newText;
        });
        
        const currentStorage = this.getStorage();
        if (donation_text) { 
          currentStorage.donation_text = donationTexts[0]?.textContent;
          FCBH.saveToStorage(this.formCampaign.localForm, currentStorage);
        } else {
          FCBH.saveToStorage(this.formCampaign.localForm, {...currentStorage, "donation_text": donationTexts[0]?.textContent});    
        }
    }

    processDefaultProgramMessage() {
      this.saveFormInStorage("donation_message", getMeta("donationMessage")||this.ccDonationTextEl[0]?.textContent || "to give God's Word!");
      this.saveFormInStorage("default_donation_message", this.ccDonationTextEl[0]?.textContent || "You’re donating to give God's Word!");
      this.saveFormInStorage("donation_text", this.ccDonationTextEl[0]?.textContent);
    }
  
    processDefaultType() {
      const isRecurring = this.donationType?.toLowerCase() === 'yes' || this.donationType?.toLowerCase() === 'monthly' ;
      let recurring_donation = 'no';
      if(isRecurring) {
        this.dayOfMonthEl?.classList?.remove('hidden');
        this.recurringDayEl?.classList?.remove('hidden');
        recurring_donation = this.recurringDayEl?.value?? '5';
      } else {
        this.dayOfMonthEl?.classList?.remove('hidden');
        this.dayOfMonthEl?.classList?.add('hidden');
        this.recurringDayEl?.classList?.remove('hidden');
        this.recurringDayEl?.classList?.add('hidden');
      }
      this.saveFormInStorage("recurring_donation", recurring_donation);
    }

    getAmount() {
      return this.getStorage()?.amounts?.usdValue;
    }

    getLocalAmount() {
      return this.getStorage()?.amounts?.value;
    }

    getLocalCurrency() {
      return this.getStorage()?.currency_code || this.defaultCurrency;
    }

    getPledgeMessage() {
      return this.getStorage()?.pledge_message;
    }
    getStorage() {
        const current = FCBH.getFromStorage(this.formCampaign.localForm) ?? {};
        return { ...current };
    }

   getPrograms() {
    return document.getElementById("vision-2033")
      ? DONATION_PROGRAMS[document.getElementById("vision-2033").value]
      : DONATION_PROGRAMS.default;
  }

   saveFormInStorage(key, value) {
        const current = this.getStorage();
        const updates = (typeof key === "object" && value === undefined) ? key : { [key]: value };
        const newForm = {
          ...current,
          program: this.getPrograms(),
          campaign: this.formCampaign.campaign,
          ...updates
        };
        hideErrors(this.errorBlockSelector);
        FCBH.deleteFromStorage(this.formCampaign.localForm);
        FCBH.saveToStorage(this.formCampaign.localForm, newForm);
        this.updateDonationText(newForm);
  }
}